// Re-exported from the module-level constants (shared with the Reservations table)
import { OPERATOR_TO_COLLECT_LABELS } from "../../constants"

// Maps the API tag `color` field to an Ant Design Tag color
export const TAG_COLOR_MAP = {
  green: "success",
  orange: "warning",
  orangeRed: "error",
  red: "error",
  default: "default"
}

// Forces specific tag colors by label string, regardless of the API color field
export const LABEL_COLOR_OVERRIDE = {}

export { OPERATOR_TO_COLLECT_LABELS }

// Labels rendered with the neutral "operator" tag style instead of a status color.
// "Link Sent" shares the same treatment as "Operator to Collect".
export const NEUTRAL_STYLE_LABELS = [...OPERATOR_TO_COLLECT_LABELS, "Link Sent"]

// Dynamic labels (carry a trailing date, e.g. "Auto-collect on 09/30/2026") that also
// use the neutral style — matched by prefix since the exact string varies.
export const NEUTRAL_STYLE_LABEL_PREFIXES = ["Auto-collect on"]

export const isNeutralStyleLabel = (label) =>
  NEUTRAL_STYLE_LABELS.includes(label) ||
  NEUTRAL_STYLE_LABEL_PREFIXES.some((prefix) => label?.startsWith(prefix))

// Labels using the white surface but keeping the error color (e.g. a failed auto-collection)
export const ERROR_STYLE_LABELS = ["Auto-collection failed"]

export const isErrorNeutralStyleLabel = (label) => ERROR_STYLE_LABELS.includes(label)

// Refund labels rendered with the light-blue surface + purple text refund chip.
export const REFUND_STYLE_LABELS = ["Refunded", "Partially Refunded", "Refund", "Partial Refund"]

export const isRefundStyleLabel = (label) => REFUND_STYLE_LABELS.includes(label)

export const PAYMENT_FILTER_OPTIONS = [
  { value: "all", label: "All payment statuses" },
  { value: "balance_due_operator_to_collect", label: "Balance Due (Operator To Collect)" },
  { value: "balance_due_card_auto_collect", label: "Balance Due Card (Auto-collect on date)" },
  { value: "balance_due_card_auto_collect_failed", label: "Balance Due Card (Auto-collection failed)" },
  { value: "balance_due_link_sent", label: "Balance Due (Link Sent)" }
]
